import AddIcon from '@mui/icons-material/Add';
import { Grid, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { WsButton, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import RLIcon from '../../../../../images/jobBoardsIcons/RL.jpeg';
import NativeSearchSettings from '../../../NativeSearchSettings';
import { NativeDialogHeader } from '../dice/DiceNewAccount';

const ResumeLibraryAdd = () => {
  const navigate = useNavigate();
  return (
    <NativeSearchSettings>
      <Box>
        <NativeDialogHeader>
          <Grid container>
            <Grid item container xs={10} columnGap={2}>
              <img src={RLIcon} alt="RLIcon" height="35" />
              <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
                Resume Library
              </WsTypography>
            </Grid>
            <Grid item xs={2} container justifyContent="flex-end">
              <WsButton
                disabled={true}
                startIcon={<AddIcon fontSize="small" />}
                onClick={() => navigate('/native-search-settings/resume-library-add')}
              >
                Add account
              </WsButton>
            </Grid>
          </Grid>
        </NativeDialogHeader>
        <Box bgcolor="white">
          <Grid container p={4} rowGap={3}>
            <Grid item xs={12}>
              <WsTypography>Resume Library ComingSoon.</WsTypography>
            </Grid>
            <Grid item xs={12}>
              <WsButton
                disabled={true}
                startIcon={<AddIcon fontSize="small" />}
                size="large"
                onClick={() => navigate('/native-search-settings/resume-library-add')}
              >
                Add account
              </WsButton>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </NativeSearchSettings>
  );
};

export default ResumeLibraryAdd;
